import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const bookerSignupManagementRoute: RouteConfig<'with-page'> = {
    name: 'Signups',
    path: '/booker/signups',
    page: lazy(() => import('.')),
    flags: ['work-in-progress']
}